const DOTS = Array.from({ length: 12 }, (_, i) => {
  const a = (-90 + i * 30) * (Math.PI / 180);
  return { cx: 32 + 23 * Math.cos(a), cy: 32 + 23 * Math.sin(a), r: i % 3 === 0 ? 4.2 : 2.6 };
});

export const LogoMark = ({ size = 34, className = "" }) => (
  <svg viewBox="0 0 64 64" width={size} height={size} className={className} aria-hidden="true">
    {DOTS.map((d, i) => (
      <circle key={i} cx={d.cx} cy={d.cy} r={d.r} fill="#A89680" opacity={i % 3 === 0 ? 1 : 0.5} />
    ))}
    <text
      x="32"
      y="41.5"
      textAnchor="middle"
      fill="currentColor"
      fontFamily="'Cormorant Garamond', Georgia, serif"
      fontSize="27"
      fontStyle="italic"
    >
      Z
    </text>
  </svg>
);

export const Logo = ({ subline = "Beads", markSize = 36, className = "" }) => (
  <span className={`flex items-center gap-3 ${className}`}>
    <LogoMark size={markSize} className="shrink-0" />
    <span className="flex flex-col leading-none">
      <span className="font-display text-2xl tracking-[0.2em] md:text-[26px]">ZOYA</span>
      {subline && <span className="label-eyebrow mt-[4px] text-[9px] text-sand">{subline}</span>}
    </span>
  </span>
);
